import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'Components/Button';
import HollowButton from 'Components/Button/HollowButton';
import PrimaryButton from 'Components/Button/PrimaryButton';
import RightPointerIcon from 'Components/icons/right-pointer-icon';

import './WizardAccordion.scss';

const WizardAccordion = ({
  id,
  headerText,
  isOpen,
  toggleAccordion,
  children,
  directionalText,
  leftLinkButtonText,
  leftLinkButtonAction,
  linkButtonText,
  secondaryButtonText,
  secondaryButtonAction,
  primaryButtonAction,
  primaryButtonText,
  showFooterLeft,
  hideToggleButton,
  headerActionMethod,
  contentIndex,
  headerButtonName,
  headerButtonStyle,
  pageSelected,
  showEditButton,
  handleOnlyOnSymbol,
  width,
  isGridCompact,
}) => {
  const headerClass = classnames('wizard-accordion__header', {
    'wizard-accordion__header--toggled': isOpen,
  });

  const toggleClass = classnames('wizard-accordion__toggler customButtonSymbol', {
    'wizard-accordion__toggler--expanded': isOpen,
    'wizard-accordion__toggler--collapsed': !isOpen,
  });

  const bodyClass = classnames(handleOnlyOnSymbol && isOpen ? '' : 'wizard-accordion__body', {
    'wizard-accordion__body--expanded': isOpen,
  });

  const headerButton = headerButtonName && <button tabIndex={0} type="button" onClick={() => headerActionMethod(contentIndex)} className="edit-btn">{headerButtonName}</button>;
  return (
    <article className="wizard-accordion__wrapper" style={{ width: width, marginBottom: isGridCompact ? 0 : '' }}>
      <header
        role="button"
        tabIndex={0}
        className={headerClass}
        onClick={!handleOnlyOnSymbol ? () => toggleAccordion(id) : null}
        id={id}
        style={{ border: '1px solid #c4c4c4' }}
      >
        {!hideToggleButton && <span onClick={handleOnlyOnSymbol ? () => toggleAccordion(id) : null} className={toggleClass} />}
        <div style={{ width: '620px' }} className="wizard-headline">
          <h1 className="wizard-accordion__headline">{headerText}</h1>
        </div>
        {/* <h1 className="wizard-accordion__headline"> {pageSelected} </h1> */}
        {showEditButton === true && headerButton}
      </header>
      <div className={bodyClass}>
        <div>
          <div className="wizard-accordion__content">
            {children}
          </div>
          {(linkButtonText || secondaryButtonText || primaryButtonText) && (
            <footer className="wizard-accordion__footer">
              <div className="wizard-accordion__footer-left">
                {
                  (showFooterLeft && leftLinkButtonText.length > 0)
                  && (
                    <Button
                      action={leftLinkButtonAction}
                      category="link-inline"
                    >
                      {leftLinkButtonText}
                    </Button>
                  )
                }
              </div>
              <div className="wizard-accordion__footer-right">
                {
                  directionalText.length > 0
                  && (
                    <span className="wizard-accordion__footer-right-text">
                      {directionalText}
                      {' '}
                      <RightPointerIcon />
                    </span>
                  )
                }
                {linkButtonText
                  && (
                    <Button
                      action={toggleAccordion}
                    >
                      {linkButtonText}
                    </Button>
                  )}
                {secondaryButtonText && <HollowButton>{secondaryButtonText}</HollowButton>}
                {
                  primaryButtonText
                  && (
                    <PrimaryButton
                      action={() => primaryButtonAction(id)}
                    >
                      {primaryButtonText}
                    </PrimaryButton>
                  )
                }
              </div>
            </footer>
          )}
        </div>
      </div>
    </article>
  );
};

WizardAccordion.propTypes = {
  directionalText: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  leftLinkButtonText: PropTypes.string,
  leftLinkButtonAction: PropTypes.func,
  linkButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  primaryButtonAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  showFooterLeft: PropTypes.bool,
  hideToggleButton: PropTypes.bool,
  isAttachImage: PropTypes.bool,
  handleOnlyOnSymbol: PropTypes.bool,
  isGridCompact: PropTypes.bool,
};

WizardAccordion.defaultProps = {
  handleOnlyOnSymbol: false,
  directionalText: '',
  leftLinkButtonText: '',
  leftLinkButtonAction: () => { },
  linkButtonText: '',
  secondaryButtonText: '',
  primaryButtonAction: () => { },
  primaryButtonText: '',
  showFooterLeft: false,
  hideToggleButton: false,
  isAttachImage: false,
  pageSelected: '0 Pages Selected',
  width: '745px',
  isGridCompact: false,
};

export default WizardAccordion;
